<template>
    <div class="login-container">
          <!-- Dynamic Alert for Displaying Messages -->
      <b-alert :show="!!responseMessage.message" :variant="responseMessage.type">
        {{ responseMessage.message }}
      </b-alert>
      <form @submit.prevent="login">
        <div class="form-group">
          <label for="username">Username:</label>
          <input type="text" id="username" v-model="username" required>
        </div>
        <div class="form-group">
          <label for="password">Password:</label>
          <input type="password" id="password" v-model="password" required>
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  </template>
  
  <script>
  import { mapState,mapActions } from 'vuex';

  export default {
    data() {
      return {
        username: '',
        password: ''
      };
    },
    computed: {
      ...mapState({
        responseMessage: state => state.responseMessage
      })
    },
    methods: {
      ...mapActions(['updateResponseMessage']),
      login() {
        const credentials = {
          username: this.username,
          password: this.password
        };
        this.$store.dispatch('login', credentials)
          .then(() => {
            this.updateResponseMessage({ message: '' , type: ''});
            this.$router.push('/'); // Redirect on success

          })
          .catch(error => {
            alert('Failed to login. Please check your credentials.'); // Simple error feedback
          });
      }
    }

  };
  </script>
  
  <style scoped>
  .login-container {
    max-width: 300px;
    margin: 50px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    display: block;
  }
  
  .form-group input {
    width: 100%;
    padding: 8px;
    line-height: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  button:hover {
    background-color: #0056b3;
  }
  </style>
  